export default "__VITE_ASSET__ClTonj6l__"